import axios from 'axios';

// Production always uses the current origin so Nginx routes /api to FastAPI.
// This deliberately ignores a developer's local .env during production builds.
const BACKEND_URL = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000');
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rec_admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Helper to build absolute file URLs (backend serves stored media)
export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (typeof pathOrUrl !== 'string') return '';
  // If it's already an absolute URL, return as-is
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  // If it starts with /api/files, prepend backend URL
  if (pathOrUrl.startsWith('/api/')) return `${BACKEND_URL}${pathOrUrl}`;
  // Local /assets/... files (public folder)
  return pathOrUrl;
}
